import { IconName } from '../../ui';

// Couleurs des tags de catégorie (fond pastel ; texte commun).
export const TAG_COLORS: Record<string, string> = {
  Lieu: '#e8eef9', Repas: '#fbede3', Photo: '#f3e8f7', Invités: '#e4f3ee', Tenues: '#fceaec', Animation: '#fff5d9',
  Cérémonie: '#e6f2f8', Déco: '#eff0e3', Papeterie: '#f7e9e1', Alliances: '#eeeeec', Beauté: '#fceaec', Démarches: '#e6f2f8',
  'Jour J': '#fff5d9', Budget: '#e4f3ee', Transport: '#eceaf8', Autre: '#f1f1ef',
};
export const TAGS = Object.keys(TAG_COLORS);

// Raccourcis vers les pages concernées (onglet de l'admin + libellé)
export const TASK_LINKS: Record<string, { tab: 'seating' | 'guests' | 'site' | 'budget' | 'dayplan'; label: string; query?: string }> = {
  invites: { tab: 'guests', label: 'Ajouter mes invités' },
  plan: { tab: 'seating', label: 'Plan de table' },
  relance: { tab: 'guests', label: 'Invités sans réponse', query: '?reponse=pending' },
  'fp-send': { tab: 'site', label: 'Votre lien' },
  soldes: { tab: 'budget', label: 'Budget' },
  deroule: { tab: 'dayplan', label: 'Déroulé' },
  'confirm-nombres': { tab: 'guests', label: 'Présents' },
  'flex-budget': { tab: 'budget', label: 'Budget' },
  'flex-site': { tab: 'site', label: 'Site' },
};

// Prestataires et préparatifs demandés à l'étape 2 de l'onboarding
export const STATUS_GROUPS: Array<{ title: string; items: Array<[string, string, string]> }> = [
  {
    title: 'Prestataires',
    items: [
      ['lieu', 'Lieu de réception', 'Domaine, salle…'],
      ['traiteur', 'Traiteur', 'Repas et boissons'],
      ['photo', 'Photographe', ''],
      ['video', 'Vidéaste', ''],
      ['musique', 'DJ ou musiciens', ''],
      ['fleurs', 'Fleuriste', 'Bouquet, déco florale'],
      ['beaute', 'Coiffure et maquillage', 'Ou vous vous en chargez vous-même'],
      ['officiant', 'Officiant de cérémonie laïque', ''],
      ['transport', 'Transport', 'Voiture des mariés, navette invités'],
    ],
  },
  {
    title: 'Préparatifs',
    items: [
      ['tenues', 'Tenues', 'Robe, costume'],
      ['alliances', 'Alliances', ''],
      ['std', 'Save the date', ''],
      ['fairepart', 'Faire-part', ''],
      ['liste', 'Liste de mariage', ''],
      ['heberg', 'Hébergements pour les invités', ''],
      ['eglise', 'Préparation religieuse', ''],
    ],
  },
];

export const LEVEL_OPTIONS: Array<{ key: 'overview' | 'balanced' | 'detailed'; label: string; hint: string; bars: number; icon: IconName }> = [
  { key: 'overview', label: 'Vue d’ensemble', hint: 'Les grandes étapes, pour garder le cap', bars: 1, icon: 'flag' },
  { key: 'balanced', label: 'Équilibré', hint: 'Toutes les tâches, sans entrer dans le détail', bars: 2, icon: 'flag' },
  { key: 'detailed', label: 'Pas à pas', hint: 'Toutes les tâches, jusqu’aux plus petites', bars: 3, icon: 'flag' },
];
